import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { TypeUtilisateur } from '@lexi-clients/lexi';
import { OidcUaaConfig, QUERY_KEY_RETURN_URL, UaaService } from '@lexi/oidc-uaa';
import { AuthService } from '../settings/auth.service';

@Injectable({
  providedIn: 'root'
})
export class IsCollaborateurGuard  {

  constructor(
    private authService: AuthService,
    private router: Router, private uaa: UaaService, private config: OidcUaaConfig
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if(this.authService.securityUser?.typeUtilisateur == TypeUtilisateur.collaborateur) {
      return true;
    }

    this.router.navigate([this.config.openIDConfiguration.forbiddenRoute], { queryParams: { [QUERY_KEY_RETURN_URL]: state.url }});
    return false;
  }

}
